// extracted by mini-css-extract-plugin
module.exports = {"root":"TicketPriceBox_root__rcDzE","details":"TicketPriceBox_details__vYxEs","price":"TicketPriceBox_price__5iRIH","date":"TicketPriceBox_date__Bvii9"};